import type { AppConfigJSON } from "@bingo/contract-fan-api";

const INJECTED_CONFIG_KEY = "__APP_CONFIG";

/**
 * Returns the runtime app config that fan-api injected into the served HTML
 * (or `null` when there is no config — typical in early bootstrap or when the
 * page was served without a resolvable app).
 */
export function getInjectedConfig(): AppConfigJSON | null {
  if (typeof window === "undefined") {
    return null;
  }

  const config = (
    window as unknown as { [INJECTED_CONFIG_KEY]?: AppConfigJSON | null }
  )[INJECTED_CONFIG_KEY];

  return config ?? null;
}
